import React from "react";
import "./WhurzItContents.css"

class WhurzitContents extends React.Component {

    constructor(props) {
        /* We MUST call the parent class contructor and send it the props object */
        super(props);

        // Setting the initial state of the NormalForms component
        this.state =
            {
                contents: this.props.value
            };

        }

        onSinglePageClick = () =>
        {
            this.props.switcher(1);
        }

        

        onOodClick = () =>
        {
            this.props.switcher(2);
        }

        onEncryptClick = () =>
        {
            this.props.switcher(3);
        }

         onStorageClick = () =>
        {
            this.props.switcher(4);
        }


    render() {
        return (

            <div className='WhurzitContents scroll-div'>

            <h1>Overview</h1>
            <p>WhurzIt is a simple personal inventory "program."  I say program
            because it is less a webpage than it is an example of "Software
            as a Service."  WhurzIt also has a maintained bug reporting page
            at <a href={"https://whurzit.charles-w-roberts.com/Bugs.html"} 
            target={"_blank"}>https://WhurzIt.Charles-W-Roberts.com/Bugs.html/</a></p>

            <p>Using WhurzIt is simple and intuitive.  The user enters items 
            and places, and then assigns items to places.  Then, WhurzIt allows
            the user to search the entire database for items and look at lists
            of items that are stored in a particular place.</p>

            <p><i>Click on a feature of WhurzIt to learn more about that feature.</i></p>

            <p className="Bullet"> ▶      </p>
            <p className="ContentItem" onClick={this.onSinglePageClick}>Single Page Application</p>
            <br/>
            <br/>
            

            <p className="Bullet"> ▶  </p>
            <p className="ContentItem" onClick={this.onOodClick}>Object Oriented Design</p>
            <br/>
            <br/>
            
            <p className="Bullet"> ▶  </p>
            <p className="ContentItem" onClick={this.onEncryptClick}>Encryption</p>
            <br/>
            <br/>

            <p className="Bullet"> ▶  </p>
            <p className="ContentItem" onClick={this.onStorageClick}>Data Storage</p>
            <br/>
            

             
  
            </div>

        )

    }

}

export default WhurzitContents;



// WEBPACK FOOTER //
// ./src/components/WhurzIt/WhurzItContents.js